<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M23.9 11.4l-2.5-2.3c-.1-.1-.2-.1-.3-.1h-7.5V1.8c0-.2-.2-.4-.4-.4H11c-.2 0-.4.2-.4.4v2.8H2.9c-.1 0-.2 0-.3.1L.1 7c-.1.1-.1.2-.1.4 0 .1.1.2.2.3l2.5 2c.1.1.2.1.3.1h7.5v12.4c0 .2.2.4.4.4h2.2c.2 0 .4-.2.4-.4v-8.1H21c.1 0 .2 0 .3-.1l2.5-2c.1-.1.2-.2.2-.3 0-.1 0-.2-.1-.3zM3.1 8.9l-2-1.6 2-1.9h7.4v3.5H3.1zm9.5 12.9h-1.3V2.2h1.3v19.6zm8.3-8.5h-7.4V9.8h7.4l2 1.9-2 1.6z"
    />
  </svg>
</template>
